<template>
  <v-list v-model:selected="selected" mandatory>
    <v-list-item :subtitle="t('messages.settingBrowserSpecific', 1)" />

    <v-list-item v-bind="auto">
      <template #prepend="{ isActive }">
        <v-icon v-if="isActive" :icon="mdiCheck" />
      </template>
    </v-list-item>

    <v-list-item v-bind="dark">
      <template #prepend="{ isActive }">
        <v-icon v-if="isActive || isDarkTheme" :class="{ auto: !isActive }" :icon="mdiCheck" />
      </template>
    </v-list-item>

    <v-list-item v-bind="light">
      <template #prepend="{ isActive }">
        <v-icon v-if="isActive || !isDarkTheme" :class="{ auto: !isActive }" :icon="mdiCheck" />
      </template>
    </v-list-item>
  </v-list>
</template>

<script lang="ts" setup>
import { mdiCheck } from '@mdi/js';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import { useThemeColorMode } from './composables/useThemeColorMode';
import { useThemes } from './composables/useThemes';

const { t } = useI18n();
const { isDarkTheme, store } = useThemeColorMode();

const selected = computed({
  get() {
    return [store.value] as [typeof store.value];
  },
  set(value: [typeof store.value]) {
    [store.value] = value;
  },
});

const { items: [auto, dark, light] } = useThemes();
</script>

<style lang="scss" scoped>
.auto {
  opacity: .2;
}
</style>
